import {
  emailNotMenValidator,
  emptyValidator,
  formValidator,
  mobilePhoneMenValidator,
  mobilePhoneNotMenValidator,
  nicValidator,
} from "../../validators";
import {
  calculateAgeFromDob,
  isMedicalCertificateValid,
} from "./documentRequirementHelper";

const employeeValidationStatus = {
  empFullName: {
    validators: [emptyValidator()],
    name: "Full Name",
  },
  // empCommonName: {
  //   validators: [emptyValidator()],
  //   name: "Common Name",
  // },
  empNic: {
    validators: [emptyValidator(), nicValidator()],
    name: "NIC",
  },
  empCategory: {
    validators: [emptyValidator()],
    name: "Category",
  },
  empAuthorized: {
    validators: [emptyValidator()],
    name: "Authorized",
  },
  empActive: {
    validators: [emptyValidator()],
    name: "Active",
  },

  empBirthDate: {
    validators: [emptyValidator()],
    name: "Birthday"
  },

  empAvc: {
    validators: [emptyValidator()],
    name: "AVC",
  },
  empStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  empMobile: {
    validators: [mobilePhoneMenValidator(), emptyValidator()],
    name: "Mobile",
  },
  empEmail: {
    validators: [emailNotMenValidator()],
    name: "Email",
  },
  empPhone: {
    validators: [mobilePhoneNotMenValidator()],
    name: "Phone",
  },
};

export const employeeValidation = (employee) => {
  const errors = formValidator(employee, employeeValidationStatus);
  if (Number(employee?.empCategory) === 1) {
    if (!employee?.empLicenceNumber || String(employee.empLicenceNumber).trim() === "") {
      errors.empLicenceNumber = "Licence Number is required";
    }
    if (!employee?.empExpiryDate || String(employee.empExpiryDate).trim() === "") {
      errors.empExpiryDate = "Licence Expiry Date is required";
    }
  }

  // Medical Certificate validation for drivers aged 60 and above (Authorized & Ad Hoc)
  if (
    Number(employee?.empCategory) === 1 &&
    Number(employee?.empAuthorized) !== 4 &&
    employee?.empAuthorized
  ) {
    const age = calculateAgeFromDob(employee?.empBirthDate);
    if (age !== "" && Number(age) >= 60) {
      if (!employee?.empMedicalIssueDate || String(employee.empMedicalIssueDate).trim() === "") {
        errors.empMedicalIssueDate = "Medical Certificate Issue Date is required for drivers aged 60 and above";
      } else {
        const today = new Date().toISOString().split("T")[0];
        if (employee.empMedicalIssueDate > today) {
          errors.empMedicalIssueDate = "Medical Certificate Issue Date cannot be in the future";
        } else if (!isMedicalCertificateValid(employee.empMedicalIssueDate)) {
          errors.empMedicalIssueDate = "Medical Certificate has expired (validity is 2 years from issue date)";
        }
      }
    }
  }

  return errors;
};

const contactValidationStatus = {
  conType: {
    validators: [emptyValidator()],
    name: "Type",
  },
  conTitle: {
    validators: [emptyValidator()],
    name: "Title",
  },
  conName: {
    validators: [emptyValidator()],
    name: "Name",
  },
  conDepartment: {
    validators: [emptyValidator()],
    name: "Department",
  },
  conMobile: {
    validators: [emptyValidator()],
    name: "Mobile",
  },
  conEmail: {
    validators: [emptyValidator()],
    name: "Email",
  },
  conAddress: {
    validators: [emptyValidator()],
    name: "Address",
  },
  conState: {
    validators: [emptyValidator()],
    name: "State",
  },
  conDistrict: {
    validators: [emptyValidator()],
    name: "District",
  },
  conCity: {
    validators: [emptyValidator()],
    name: "City",
  },
  conCountry: {
    validators: [emptyValidator()],
    name: "Country",
  },
  conStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  conActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};

export const employeeContactValidation = (contactData) =>
  formValidator(contactData, contactValidationStatus);
